export default {
    data: () => ({
        translations: {
            title: {
                el: "Εκκαθάριση Πληρωμής",
                en: "Payment Processing",
                it: "Processo di Pagamento"
            },
            info: {
                el: "Εδώ μπορείτε να επιλέξετε τους παρόχους που προτιμάτε να επεξεργάζονται πληρωμές, για την κάθε κάρτα πληρωμής (που έχει εκδοθεί από την κάθε τράπεζα). Για κάθε μία από τις κάρτες πληρωμών που αναφέρονται στα αριστερά, μπορείτε να επιλέξετε τον πάροχο που θα εκκαθαρίσει τις πληρωμές στα δεξιά (κάντε κλικ στο όνομα του παρόχου για να ανοίξετε το modal και να αλλάξετε την επιλοφή σας μέσω αυτού του modal).",
                en: `
                    Here you can select the providers that you prefer to process payments, for each payment card (issued by each bank). For each of the payment cards listed on the left, you can select the payment processor on the right (click on the name of the provider to open the modal and change it through that modal).
                `,
                it: "Qui puoi selezionare i fornitori che preferisci per elaborare i pagamenti, per ogni carta di pagamento (emessa da ciascuna banca). Per ciascuna delle carte di pagamento elencate a sinistra, è possibile selezionare il processore di pagamento a destra (fare clic sul nome del provider per aprire la modalità e modificarla tramite quella modalità)."
            },
            cardIssued: {
                el: "Όταν η κάρτα πληρωμής του πελάτη εκδίδεται από (τράπεζα):",
                en: "When the customer's payment card is issued by (bank):",
                it: "Quando la carta di pagamento del cliente è emessa da (banca):"
            },
            processPayment: {
                el: "Η εκκαθάριση να γίνεται από (πάροχο):",
                en: "Payments should be processed by (provider):",
                it: "Autorizzazione da parte di (fornitore):"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            chooseBank: {
                el: "",
                en: "Choose Bank Provider",
                it: ""
            }
        }
    })
};
